import React, { useState } from "react";

const Step2 = ({ formData, nextStep, previousStep }) => {
  if (formData.choice === "option1") {
    return <Option1Form nextStep={nextStep} previousStep={previousStep} />;
  } else if (formData.choice === "option2") {
    return <Option2Form nextStep={nextStep} previousStep={previousStep} />;
  } else {
    return (
      <div>
        Choose an option in Step 1<button onClick={previousStep}>Back</button>
      </div>
    );
  }
};

const Option1Form = ({ nextStep, previousStep }) => {
  const [ageOption, setAgeOption] = useState("");

  return (
    <div>
      <h3>Are you 18 years or over?</h3>
      <select value={ageOption} onChange={(e) => setAgeOption(e.target.value)}>
        <option value="">--Select an option--</option>
        <option value="yes">Yes, I am 18 years or over</option>
        <option value="no">No, my guardian will be the account holder</option>
      </select>
      <div>
        <button onClick={() => nextStep({ ageOption })}>Next</button>
      </div>
    </div>
  );
};

const Option2Form = ({ nextStep, previousStep }) => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");

  return (
    <div>
      <h3>Enter friend or family member details:</h3>
      <input
        type="text"
        placeholder="First Name"
        value={firstName}
        onChange={(e) => setFirstName(e.target.value)}
      />
      <input
        type="text"
        placeholder="Last Name"
        value={lastName}
        onChange={(e) => setLastName(e.target.value)}
      />
      <div>
        <button onClick={() => nextStep({ firstName, lastName })}>Next</button>
      </div>
    </div>
  );
};

export default Step2;
